import { FetchResponse } from '@cian/http-api';
import { CancellationToken } from '@cian/http-api/shared';
import { ResponseError } from 'shared/common/errors';
import {
  fetchGetNewbuildingPromoSnippetForMap,
  IGetNewbuildingPromoSnippetForMapRequest,
  TGetNewbuildingPromoSnippetForMapResponse,
} from 'shared/common/repositories/newbuilding-content-promotion/v1/get-newbuilding-promo-snippet-for-map';

import type { IGetNewbuildingPromoSnippetForMapResponse } from 'shared/common/repositories/newbuilding-content-promotion/entities/response/GetNewbuildingPromoSnippetForMapResponse';

import { IApplicationContext } from '../../../types/applicationContext';

export async function fetchNewbuildingPromoPopup(
  context: IApplicationContext,
  parameters: IGetNewbuildingPromoSnippetForMapRequest,
): Promise<IGetNewbuildingPromoSnippetForMapResponse | null | undefined> {
  const { httpApi, cancellationTokenManager } = context;

  let cancellationToken: CancellationToken | undefined;
  if (cancellationTokenManager) {
    cancellationToken = cancellationTokenManager.getTokenAndCancelPrevious('fetchGetNewbuildingPromoPopup');
  }

  const result: FetchResponse<TGetNewbuildingPromoSnippetForMapResponse> = await fetchGetNewbuildingPromoSnippetForMap({
    httpApi,
    parameters: { ...parameters },
    config: { cancellationToken },
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchNewbuildingPromoPopup',
      message: `Server responded with ${result.statusCode}`,
    });
  }

  return result.response;
}
